import * as ngCore from '@angular/core'
import * as ngRouter from '@angular/router'

import * as state from '../../state'

import * as floaters from './floaters'
import * as navbar from './navbar'

/**
 * Entry point for the main platform
 */
@ngCore.Component({
  imports: [ngRouter.RouterOutlet, navbar.Component, floaters.Component],
  selector: 'atn-platform',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /**
   * @see {@link navbar.Store}
   *
   * TODO: Consider to move store from navbar to platform
   */
  public readonly navbarStore = ngCore.inject(navbar.Store)
  /** @see {@link state.navigation.Feature} */
  public readonly navigationFeature = ngCore.inject(state.navigation.Feature)

  private readonly _transitionStepSg = ngCore.signal(0)

  /** Message shown while the platform swaps between route-bound views. */
  public readonly transitionMessageSg = ngCore.computed(
    (step = this._transitionStepSg()) =>
      TRANSITION_MESSAGES[step % TRANSITION_MESSAGES.length],
  )

  private readonly _transitionMessageEffect = ngCore.effect(onCleanup => {
    if (!this.navigationFeature.selectors.isTransitioning.asSignal()) {
      this._transitionStepSg.set(0)
      return
    }

    const interval = setInterval(
      () => this._transitionStepSg.update(step => step + 1),
      800,
    )

    onCleanup(() => {
      clearInterval(interval)
    })
  })
}

const TRANSITION_MESSAGES = [
  'Loading content...',
  'Applying page context...',
  'Preparing workspace...',
] as const
